import type { IconPropsWithoutName } from '../index'

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const SmartPhone: React.FC<IconPropsWithoutName> = ({ className }: { className?: string }) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; the Icon wrapper carries the accessible name
  <svg className={className} width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="54" height="54" rx="27" fill="#0AABC5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1665 16.5003C20.5222 16.5003 19.9998 17.0227 19.9998 17.667V36.3337C19.9998 36.978 20.5222 37.5003 21.1665 37.5003H32.8332C33.4775 37.5003 33.9998 36.978 33.9998 36.3337V17.667C33.9998 17.0227 33.4775 16.5003 32.8332 16.5003H21.1665ZM17.6665 17.667C17.6665 15.734 19.2335 14.167 21.1665 14.167H32.8332C34.7662 14.167 36.3332 15.734 36.3332 17.667V36.3337C36.3332 38.2667 34.7662 39.8337 32.8332 39.8337H21.1665C19.2335 39.8337 17.6665 38.2667 17.6665 36.3337V17.667ZM25.8332 34.0003C25.8332 33.356 26.3555 32.8337 26.9998 32.8337H27.0115C27.6558 32.8337 28.1782 33.356 28.1782 34.0003C28.1782 34.6447 27.6558 35.167 27.0115 35.167H26.9998C26.3555 35.167 25.8332 34.6447 25.8332 34.0003Z"
      fill="black"
    />
  </svg>
)
